module.exports = __webpack_public_path__ + "static/media/engine-oil-filters-mr-card-back.06814cc6.jpeg";